import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgStarFilled = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12.98 3.959a1.09 1.09 0 0 0-.982-.608c-.42 0-.798.236-.982.608l-2.192 4.47-4.895.715c-.409.061-.75.345-.876.733a1.08 1.08 0 0 0 .27 1.105l3.551 3.483-.838 4.922a1.08 1.08 0 0 0 .44 1.058c.337.24.783.27 1.152.077L12 18.208l4.373 2.314a1.1 1.1 0 0 0 1.152-.077c.338-.244.508-.652.44-1.058l-.842-4.922 3.552-3.483c.293-.287.399-.716.27-1.105a1.09 1.09 0 0 0-.877-.733l-4.898-.716z"
    }));
export default SvgStarFilled;
